import * as React from 'react';

import { Button, LinkButton } from '@cian/ui-kit';
import { useInView } from '@cian/valuation-utils-component';

import * as styles from './OffersListMobile.css';

export interface IOffersListMobile {
  url?: string;
  onShow?(): void;
  onMoreClick?(): void;
  hideShowMoreButton?: boolean;
}

const ShowMoreButton = ({ onMoreClick, url }: { onMoreClick?: () => void; url: string }) => {
  if (!onMoreClick) {
    return <Button data-name="MoreLinkLoading" size="L" theme="fill_secondary" fullWidth loading />;
  }

  return (
    <LinkButton
      data-name="MoreLink"
      size="L"
      theme="fill_secondary"
      fullWidth
      onClick={onMoreClick}
      href={url}
      target="_blank"
    >
      Посмотреть ещё
    </LinkButton>
  );
};

export const OffersListMobile: React.FC<React.PropsWithChildren<IOffersListMobile>> = ({
  url = '',
  children,
  onShow,
  onMoreClick,
  hideShowMoreButton = false,
}) => {
  const [isShown, setIsShown] = React.useState(false);

  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  React.useEffect(() => {
    if (inView && onShow && !isShown) {
      onShow();
      setIsShown(true);
    }
  }, [inView, onShow, isShown]);

  return (
    <div className={styles['container']} ref={ref}>
      <div className={styles['list']}>{children}</div>
      {!hideShowMoreButton && <ShowMoreButton onMoreClick={onMoreClick} url={url} />}
    </div>
  );
};
